<template>
    <b-card class="my-3 shadow-sm">
        <b-card-text>
            <!-- Display question body, value if evaluated and choices -->
            <b-container fluid>
                <b-row no-gutters>
                    <b-col cols="1">
                        <h5 class="text-right mr-3"><strong>{{ number }}.</strong></h5>
                    </b-col>
                    <b-col cols="11">
                        <h5 class="display-breaks text-justify">{{ question.body }}</h5>
                    </b-col>
                </b-row>
            </b-container>
            <b-container fluid>
                <b-row no-gutters>
                    <b-col cols="11" offset="1">
                        <p v-if="selectedSurveyObject.isEvaluated" style="font-size: 1rem">Ponderación: <strong>{{ question.valueDisplay }} %</strong></p>
                    </b-col>
                </b-row>
            </b-container>

            <!-- Validation error messages -->
            <h5
                v-if="question.choices.length < 2"
                class="ml-4 mb-4 text-danger"
            >
                <em>Esta pregunta require mínimo 2 opciones.</em>
            </h5>
            <h5
                v-else-if="question.choices.length && question.correctChoicesCount <= 0 && selectedSurveyObject.isEvaluated"
                class="ml-4 mb-4 text-danger"
            >
                <em>No hay opciones <strong>correctas</strong> para esta pregunta.</em>
            </h5>
            <h5
                v-else-if="question.answerType === 'simple' && question.correctChoicesCount > 1"
                class="ml-4 mb-4 text-danger"
            >
                <em>Preguntas de selección simple solo pueden tener <strong>una opción correcta</strong>.</em>
            </h5>

            <SurveyQuestionChoices
                :choices="question.choices"
                :answerType="question.answerType"
                :questionId="question.id"
            />
        </b-card-text>

        <template v-if="isUserStudenTeacherOrBetter && canEditSurvey" v-slot:footer>
            <div class="float-right">

                <b-button
                    v-if="canEditSurvey"
                    variant="primary"
                    size="sm"
                    class="ml-2"
                    v-b-tooltip.hover
                    title="Agregar nueva opción"
                    @click="onCreateChoice()"
                >
                    <b-icon-plus />
                </b-button>
                <!-- When moving up, emit the current question index and the previous one. -->
                <b-button
                    v-if="canEditSurvey"
                    variant="dark"
                    size="sm"
                    class="ml-2"
                    v-b-tooltip.hover
                    title="Subir pregunta"
                    :disabled="number <= 1"
                    @click="$emit('move-question-up', number - 1, number - 2 )"
                >
                    <b-icon-chevron-bar-up />
                </b-button>
                <!-- When moving down, emit the current question index and the next one. -->
                <b-button
                    v-if="canEditSurvey"
                    variant="dark"
                    size="sm"
                    class="ml-2"
                    v-b-tooltip.hover
                    title="Bajar pregunta"
                    :disabled="number >= selectedSurveyObject.numberQuestions"
                    @click="$emit('move-question-down', number - 1, number )"
                >
                    <b-icon-chevron-bar-down />
                </b-button>

                <b-button
                    v-if="canEditSurvey"
                    variant="warning"
                    size="sm"
                    class="ml-2"
                    v-b-tooltip.hover
                    title="Editar pregunta"
                    @click="onUpdateQuestion()"
                >
                    <b-icon-pencil />
                </b-button>

                <b-button
                    v-if="canEditSurvey"
                    variant="danger"
                    size="sm"
                    class="ml-2"
                    v-b-tooltip.hover
                    title="Eliminar pregunta"
                    @click="onDeleteQuestion()"
                >
                    <b-icon-trash-fill />
                </b-button>
            </div>
        </template>
    </b-card>
</template>

<script>
import SurveyQuestionChoices from './SurveyQuestionChoices'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
    name: 'SurveyQuestion',
    components: {
        SurveyQuestionChoices
    },
    props: {
        question: Object,
        number: Number
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedCrudObject',
            'selectedSurveyObject'
        ]),
        ...mapGetters([
            'isUserStudenTeacherOrBetter',
            'canEditSurvey'
        ])
    },
    methods: {
        ...mapActions([
            'readSingleSiteTeacherSurvey',
            'deleteSiteSurveyQuestion'
        ]),
        onCreateChoice () {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', null)
            this.$store.commit('SET_SELECTED_SURVEY_QUESTION_ID', this.question.id)
            this.$bvModal.show('modal-create-survey-question-choice')
        },
        onUpdateQuestion () {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', this.question)
            this.$bvModal.show('modal-create-survey-question')
        },
        async onDeleteQuestion () {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', this.question)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    '¿Esta seguro que desea eliminar esta pregunta y sus opciones?',
                    {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDeleteQuestion()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDeleteQuestion () {
            var loader = this.$loading.show()
            try {
                const payloadData = {
                    courseSiteId: this.activeSite.id,
                    questionId: this.selectedCrudObject.id,
                    surveyId: this.selectedSurveyObject.id
                }
                await this.deleteSiteSurveyQuestion(payloadData)
                var reloadPayload = { courseSiteId: this.activeSite.id, surveyId: this.selectedSurveyObject.id }
                await this.readSingleSiteTeacherSurvey(reloadPayload)
                this.$root.infoToast('La pregunta y sus opciones ha sido eliminada exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar la pregunta, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        }
    }
}
</script>
